<template>
  <v-dialog v-model="open" :max-width="task.task_type != 'install' ? 1200 : 800" @click:outside="undo">
    <template v-slot:activator="{ on }">
      <v-btn color="primary" fab large :disabled="!users" v-on="on" @click="reset">
        <v-icon x-large>mdi-plus</v-icon>
      </v-btn>
    </template>
    <ValidationObserver ref="task" v-slot="{ invalid, validated, passes }">
      <v-card>
        <v-card-title>
          <span class="headline">Task</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <ValidationProvider v-slot="{ errors }" name="title">
                      <v-text-field 
                        v-model="task.name" 
                        :error-messages="errors" 
                        label="Task Title*"
                      />
                    </ValidationProvider>
                  </v-col>
                  <div class="flex-grow-1"></div>
                  <v-col v-if="task.task_type === 'install'" cols="12" sm="6" md="5">
                    <v-checkbox v-model="autoAssign" label="Auto-assign device(s) to vehicle(s)"/>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-select v-model="task.task_type" :items="filteredActions" label="Action*"></v-select>
                  </v-col>
                  <div class="flex-grow-1"></div>
                  <v-col v-if="task.task_type === 'install'" cols="12" sm="6" md="5" class="grey-bg">
                    <ValidationProvider v-slot="{ errors }" name="Assignee" rules="required">
                      <v-select 
                        v-model="selectedOrg" 
                        :disabled="!autoAssign" 
                        :items="orgNameAndIdList" 
                        :error-messages="errors"
                        item-text="name" 
                        item-value="id" 
                        label="Organisation">
                      </v-select>
                  </ValidationProvider>
                  </v-col>
                </v-row>
                <v-row v-show="task.task_type === 'install'">
                  <v-col cols="12" sm="6" md="5">
                    <ValidationProvider
                      v-if="task.task_type === 'install'"
                      v-slot="{ errors }"
                      name="Number"
                      rules="required|min_value:1|max_value:1000"
                    >
                      <v-text-field
                        v-model="task.num_devices"
                        :disabled="mode === 'edit'"
                        :error-messages="errors"
                        min="1"
                        label="Number of Devices*"
                        type="number"
                        required
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <div class="flex-grow-1"></div>
                  <v-col v-if="task.task_type === 'install'" cols="12" sm="6" md="5" class="grey-bg">
                    <v-select 
                      v-model="selectedGroup" 
                      :loading="orgTreeLoading"  
                      :disabled="!autoAssign" 
                      item-text="name"
                      item-value="id" 
                      :items="orgGroups" 
                      label="Group">
                    </v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="5">
                    <ValidationProvider v-slot="{ errors }" name="Assignee" rules="required|email">
                      <v-autocomplete 
                        v-model="task.assigned_to"
                        label="Assignee*"
                        :items="orgUsers"
                        item-text="name"
                        item-value="email"
                        :error-messages="errors"
                        required
                      >
                      </v-autocomplete>
                    </ValidationProvider>
                  </v-col>
                  <div class="flex-grow-1"></div>

                  <v-col cols="12" sm="6" md="5">
                    <v-textarea v-model="task.description" label="Note" rows="2"></v-textarea>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="5">
                    <v-text-field v-model="task.performed_by" label="Performed By"></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="end">
                  <v-col cols="12" sm="6" md="5">
                    <v-dialog ref="dialog" v-model="modal" :return-value.sync="task.due_on" persistent width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="date" label="Due Date" prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
                      </template>
                      <ValidationProvider v-slot="{ errors }" name="Assignee" rules="required">
                        <v-date-picker 
                          v-model="task.due_on" 
                          scrollable 
                          :error-messages="errors">
                          <div class="flex-grow-1"></div>
                          <v-btn text color="primary" @click="undo">Cancel</v-btn>
                          <v-btn text color="primary" @click="$refs.dialog.save(task.due_on)">OK</v-btn>
                        </v-date-picker>
                      </ValidationProvider>
                    </v-dialog>
                  </v-col>
                </v-row>

                <v-row v-show="task.task_type === 'device_config_job'">
                  <v-col cols="6">
                    <v-text-field  
                    :value="deviceModel"
                    label="Device Model"
                    disabled
                  />
                  </v-col>
                </v-row>

                <v-row v-show="task.task_type === 'device_config_job'">
                  <v-col cols="4">
                    <v-btn
                      outlined
                      text
                      color="#2196F3"
                      @click="toggleDeviceConfig"
                    >
                      Choose Config File
                    </v-btn>
                  </v-col>

                  <v-col cols="6" class="vertical-align">
                    <span v-if="!deviceConfig" class="missing-file-error">
                      No Config File Selected
                    </span>
                    <span v-else>
                      {{ fileName }}
                    </span>
                  </v-col>
                </v-row>

                <v-row v-show="task.task_type === 'firmware_job'">
                  <v-col cols="12" md="12">
                    <ValidationProvider v-if="task.task_type === 'firmware_job'" v-slot="{ errors }" name="title" rules="required">
                      <PackageSelector 
                        v-model="selectedPackage" 
                        :error-messages="errors"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>
              <v-col v-show="task.task_type === 'firmware_job'" style="flex-grow:0;">
                <v-card class="mx-auto pa-2" width="270" height="100%" outlined>
                  <v-subheader>
                    <span class="target-header">Target Devices</span>
                    <v-icon color="primary" style="cursor:pointer;" @click="transfer = true">mdi-circle-edit-outline</v-icon>
                  </v-subheader>
                  <v-simple-table style="max-height:400px;overflow:auto;">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Vehicles</th>
                          <!-- <th class="text-left">Device</th> -->
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in selectedVehicles" :key="item.id">
                          <td>{{ item.vehicle_name }}</td>
                          <!-- <td>{{ item.devcie }}</td> -->
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-col>

              <v-col v-show="task.task_type === 'device_config_job'" style="flex-grow:0;">
                 <v-card class="mx-auto pa-2" width="270" height="100%" outlined>
                  <v-subheader>
                    <span class="target-header">Target Devices</span>
                    <v-icon :disabled="!hasConfig" :color="assignColour" style="cursor:pointer;" @click="transfer = true">mdi-circle-edit-outline</v-icon>
                  </v-subheader>
                  <v-simple-table v-if="targetOrg != 'Unassigned'" style="max-height:400px;overflow:auto;">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Vehicles</th>
                          <!-- <th class="text-left">Device</th> -->
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in selectedVehicles" :key="item.id">
                          <td>{{ item.vehicle_name }}</td>
                          <!-- <td>{{ item.devcie }}</td> -->
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <v-data-table 
                    v-else
                    :items="selectedVehicles"
                    :headers="headers"
                    disable-pagination
                    :hide-default-footer="true"
                    item-key="id"
                  />
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="blue darken-1" text @click="exit">Cancel</v-btn>
          <v-btn color="blue darken-1" :disabled="invalid || !validated" text @click="passes(submit)">Save</v-btn>
        </v-card-actions>
        <ValidationProvider v-if="task.task_type === 'firmware_job'" name="title" rules="required">
          <transfer-reverse v-model="selectedVehicles" :open="transfer" @exit="transfer = false" />
        </ValidationProvider>
         <ValidationProvider 
          v-if="hasConfig"
          name="title" 
          rules="required"
        >
          <DeviceSelector 
            v-model="selectedVehicles" 
            :table-headers="headers"
            :open="transfer" 
            :device-model="deviceModel"
            :compatibility-limit="compatibilityLimit"
            :supports-partial-config="supportsPartialConfig"
            :config-options-version-map="configOptionsVersionMap"
            @exit="handleClose" 
          />
        </ValidationProvider>
      </v-card>
    </ValidationObserver>

    <DeviceConfig 
			v-if="displayDeviceConfig"
      :key="compKey"
			:item="{}"
			:org="orgId"
      :stand-alone="true"
      :device-id="''"
      @fileName="handleFileName"
      @proceedWithConfigJob="handleEncodedConfig"
      @closeDeviceConfig="displayDeviceConfig = !displayDeviceConfig"
      @forceUpdateConfig="handleForceUpdate"
      @compatibilityLimitUpdated="handleCompatibilityLimit"
      @configOptionsVersionMap="handleConfigOptionsVersionMap"
      @configTypeUpdated="handlecConfigType"
    />
  </v-dialog>
</template>

<script>

import TransferReverse from "./TransferReverse"
import PackageSelector from "./Tasks/PackageSelector"
import DeviceSelector from "@/components/deviceConfig/components/DeviceSelector.vue"
import DeviceConfig from '@/components/deviceConfig/config.vue';

import { GetOrgTree } from "@/services/API.js";

import { Logger } from "aws-amplify"
const logger = new Logger("AddTask")

import moment from "moment"

// var xml2js = require('xml2js');

import { mapGetters, mapState } from "vuex"
import {deviceConfigMixin} from '@/mixins/deviceConfigMixin.js';

export default {
  name: "AddTask",
  components: { 
    PackageSelector, 
    TransferReverse,
    DeviceSelector,
    DeviceConfig
  },
  mixins: [deviceConfigMixin],
  props: {
    initDetails: {
      type: Object,
      required: true,
      default: () => {}
    },
    orgUsers: {
      type: Array,
      required: true
    },
    jobItem: {
      required: false,
      type: Object,
      default: () => null
    },
    orgs: {
      required: true,
      type: Array
    }
  },
  data: () => ({
    task: {},
    mode: "new",
    open: false,
    modal: false,
    selectedPackage: null,
    selectedVehicles: [],
    outsideClick: 0,
    dropped: 0,
    reenter: false,
    transfer: false,
    deviceConfig: null,
    compKey: 0,
    headers: [
      {
        text: 'Install Tag',
        value: 'install_tag',
        align: 'left'
      },
      {
        text: 'IMEI',
        value: 'imei',
        align: 'left'
      },
    ],
    targetOrg: '',
    displayDeviceConfig: false,
    encodedXML: '',
    fileName: '',
    compatibilityLimit: '',
    configOptionsVersionMap: {},
    supportsPartialConfig: true,
    autoAssign: false,
    selectedOrg: null,
    selectedGroup: null,
    orgGroups: [],
    orgTreeLoading: false
  }),
  
  computed: {
    ...mapState(["orgs", "users"]),
    ...mapGetters(["orgId", "orgName"]),
    orgNameAndIdList() {
      const orgs = this.orgs.map((org) => ({
        name: org.name,
        id: org.id,
        disabled: org.disabled
      }));

      return orgs;
    },
    date() {
      if (!this.task.due_on || this.task.due_on === "None" || this.task.due_on === "Invalid date") return moment().format("DD/MM/YYYY")

      return moment(this.task.due_on).format("DD/MM/YYYY")
    },

    assignColour() {
      return this.deviceConfig != null ? 'blue' : 'primary';
    },
    actions() {
      if (this.mode === "new") {
        return [
          { text: "Install", value: "install" },
          { text: "Firmware Update", value: "firmware_job" },
          { text: "Device Configuration", value: "device_config_job"}
        ]
      }
      return [{ text: "Install", value: "install" }]
    },
    // filters to only show the actions a user can actually complete
    filteredActions () {
      const can = {
          Install: this.$can('createDeviceInstallJob'),
          'Firmware Update': this.$can('createFirmwareUpdateJob'),
          'Device Configuration': this.$can('createDeviceConfigJob'),
      }
      return this.actions.filter(i => can[i.text])
    },
    deviceModel() {
      return this.deviceConfig != null ? this.deviceConfig.device_config.target[0].model[0] : '';
    },
    hasConfig() {
      return this.deviceModel.length > 0 ? true : false;
    },
    taskType() {
      return this.task.task_type;
    },
    devices() {
      let devices = [];

      this.selectedVehicles.forEach(item => {
        if (item.devices) {
          item.devices.forEach(device => {
            let deviceID = device.device_id;

            if (!devices.includes(deviceID)) {
              devices.push(deviceID);
            }
          });
        }
        else {
          let deviceID = item.id;

          if (!devices.includes(deviceID)) {
            devices.push(deviceID);
          }
        }
      })
      return devices;
    }
  },
  watch: {
    initDetails: {
      handler(){
          this.task.name = this.initDetails.name;
          this.task.assigned_to = this.initDetails.assigned_to;
          this.task.due_on = this.initDetails.due_on;
      },
      deep: true 
    },
    taskType(val) {
      this.$emit('setTaskType', val);

      // reset all vals related to auto assign when task type changes to anything but install
      if(val != 'install') {
        this.autoAssign = false
        this.selectedOrg = null
        this.selectedGroup = null
      }
    },
    open(val) {
      logger.info('is it open? ', val)
      this.mapInitData();
      this.handlePreSelectedDevice();
    },
    selectedOrg(id) {
      this.selectedGroup = null;
      this.fetchOrgNodes(id);
    }
  },
  mounted() {
    this.mapInitData();
    this.handlePreSelectedDevice();
  },
  methods: {
    async fetchOrgNodes(id) {
      this.orgTreeLoading = true;

      try {
        const orgTree = await GetOrgTree(id);

        if (orgTree && orgTree.hasOwnProperty('root_node')) {
          this.orgGroups =  this.flattenOrgTree([orgTree.root_node]);
          this.orgTreeLoading = false;
        }
      } catch {
        this.orgTreeLoading = false;
      }
    },

    flattenOrgTree(node) {
      try {
        var result = [];

        node.forEach((a) => {
          result.push({
            name: a.metadata.label,
            id: a.id
          });
          if (Array.isArray(a.nodes)) {
            let nextNode = this.flattenOrgTree(a.nodes)
            
            result = result.concat(nextNode);
          }
      });
      return result;

      } catch (err) {
        logger.info('error?', err)
      }
      
    },

    handlecConfigType(val) {
      this.supportsPartialConfig = val;
    },
    handleConfigOptionsVersionMap(map) {
      this.configOptionsVersionMap = map;
    },
    handlePreSelectedDevice() {
      if (!this.jobItem) return;

      // Only add vehicle/device to selectedVehicles if it is not already added
      const isInSelectedVehicles = this.selectedVehicles.indexOf(this.jobItem);
      
      if(!isInSelectedVehicles > -1) this.selectedVehicles.push(this.jobItem);
      
    },
    handleCompatibilityLimit(limit) {
      logger.info('handleCompatibilityLimit ', limit)
      this.compatibilityLimit = limit;
    },
    handleFileName(name) {
      this.fileName = name;
    },
    handleForceUpdate() {
      this.compKey++;
    },
    handleEncodedConfig(data) {
      logger.info('called handleEncodedConfig ', data)
      let decodedBase64 = atob(data);
      let jsonData = this.uploadFileFromDisk(decodedBase64)
      
      this.deviceConfig = jsonData
      this.encodedXML = data

      logger.info('test contents : ', this.deviceConfig, this.encodedXML)
    },
    toggleDeviceConfig() {
      this.displayDeviceConfig = !this.displayDeviceConfig;
    },
    handleClose(data) {
      this.transfer = false;
      this.targetOrg = data;
    },
    mapInitData() {
      
      this.task = {
        name: this.initDetails.name,
        description: "",
        assigned_to: this.initDetails.assigned_to,
        performed_by: "",
        task_type: "install",
        num_devices: "1",
        due_on: this.initDetails.due_on,
        extra_install_instructions: "",
      };
      // Reset selected config
      this.deviceConfig = null;
    },
    async submit() {
      this.open = false
      if (this.task.task_type === "firmware_job") {
        this.task.context = {
          firmware_id: this.selectedPackage.firmware_id,
          devices: this.devices
        }

        // remove propertys not supported for device config jobs
        delete this.task.num_devices;
        delete this.task.extra_install_instructions;

        this.$emit("task", {
          mode: this.mode,
          task: this.task,
        })
      } 
      else if (this.task.task_type === 'install' && this.autoAssign) {

        this.task.target = {
          org_id: this.selectedOrg,
          node_id: this.selectedGroup ? this.selectedGroup : ''
        }

        this.$emit("task", {
          mode: this.mode,
          task: this.task,
        })
      }
      else if (this.task.task_type === 'device_config_job') {
        this.task.context = {
          device_config: {
            file_format: 'xml',
            data: this.encodedXML,
          },
          devices: this.devices
        }

        // remove propertys not supported for device config jobs
        delete this.task.num_devices;
        delete this.task.extra_install_instructions;

        this.$emit("task", {
          mode: this.mode,
          task: this.task,
        })
      }
      else {
        this.$emit("task", {
          mode: this.mode,
          task: this.task,
        })
      }

      this.$emit('taskCreated');
    },
    undo() {
      this.modal = false
    },
    editTask(task) {
      logger.debug(task, this.$refs.task)
      this.mode = "edit"
      !task.due_on || task.due_on === "None" || task.due_on === "0000-00-00 00:00:00"
        ? (task.due_on = null)
        : (task.due_on = moment.utc(task.due_on).format())
      // this.task = Object.assign(defaultTask(), cleanNone(task))
      this.open = true
      this.$nextTick(() => {
        this.$refs.task.reset()
        const unwatch = this.$watch(
          "task",
          () => {
            logger.debug("validate")
            this.$refs.task.validate()
            unwatch()
          },
          {
            deep: true,
          }
        )
      })
    },

    reset() {
      logger.info('reset!', this.task, this.initDetails)
      // if (!this.$refs.task) return
      this.mode = "new"
      this.selectedVehicles = []
      this.selectedPackage = null
      requestAnimationFrame(() => {
        logger.info("requestAnimationFrame")
        this.$refs.task.validate()
      })
      // this.task = defaultTask();
    },

    exit() {
      this.open = false
      this.$emit("exit")
    },
    setTarget() {},
    loadConfigFile() {
      const [file] = document.getElementById('fileUploadJob').files;
      const reader = new FileReader();

      reader.addEventListener("load", () => {
        let config = this.uploadFileFromDisk(reader.result);

        this.deviceConfig = config;
        this.encodedXML = btoa(JSON.stringify(config));

        logger.info(this.encodedXML)
      }, false);

      if (file) {
        reader.readAsText(file);
      }      
    }
  },
}
</script>

<style lang="scss" scoped>
  .target-header {
    padding-right: 1em;
  }

  .vertical-align {
    display: flex;
    justify-content: left;
    align-items: center;
  }

  .missing-file-error {
    color: #f55a4e;
  }
  .grey-bg {
    background: #f0f0f0;
  }
</style>
